export default __webpack_public_path__ + "static/media/cc.de027043.jpg";